import { http } from '@/utils/index'

/**
 * 客户案例相关API
 */

// 查询上架案例列表（分页）
export function getOnShelfCases(params) {
  return http.request('get', '/case/onshelf', { params })
}

// 查询精选案例
export function getFeaturedCases(size = 6) {
  return http.request('get', '/case/featured', { params: { size } })
}

// 查询热门案例
export function getHotCases(size = 6) {
  return http.request('get', '/case/hot', { params: { size } })
}

// 根据ID查询案例详情
export function getCaseById(id) {
  return http.request('get', `/case/${id}`, {})
}
